import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Hoc from "../../../components/HOC";
import ModalComponent from "../../../components/Modal";
import CustomDataTable from "../../../components/CustomDataTable";
import { MdDelete, MdEdit, MdVisibility } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  setResetStateProjectsList,
  requestProjectAction,
  requestProjectById,
  requestProjectsListAction,
  setResetStateProject,
  requestEditProject,
  setResetStateProjectById,
  setResetEditProject,
} from "../../../Redux/ProjectState/ProjectActionCreator";
import Loader from "../../../components/Loader";
import AddProjectModal from "./AddProjectModal";
import { requestUsersListActionWithOutPagination } from "../../../Redux/UserState/UserActionCreator";
import { requestClientsListActionWithOutPagination } from "../../../Redux/ClientState/ClientActionCreator";
import moment from "moment";
import CustomToolTip from "../../../components/ToolTip";

const AddProject = () => {
  const [formData, setFormData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState({ title: "", isOpen: false });
  const [editIndex, setEditIndex] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const dispatch = useDispatch();
  const projectListState = useSelector((state) => state.ProjectsListReducer);
  const addProjectReducer = useSelector((state) => state.ProjectReducer);
  const editProjectReducer = useSelector((state) => state.EditProjectReducer);
  const projectByIdReducer = useSelector((state) => state.ProjectByIdReducer);
  const [search, setSearch] = useState("");
  const [editData, setEditData] = useState({});
  const usersListState = useSelector(
    (state) => state.UsersListWithOutPagination
  );
  const clientsListState = useSelector(
    (state) => state.ClientsListWithOutPagination
  );

  // Sync local search state with Redux state
  useEffect(() => {
    if (projectListState?.search !== undefined && projectListState.search !== search) {
      setSearch(projectListState.search);
    }
  }, [projectListState?.search]);

  const clients = ["Client A", "Client B", "Client C", "Client D"];
  const columns = [
    // { name: 'User Name', selector: row => row.username, sortable: true },
    { name: "Project Name", selector: (row) => row.projectName, sortable: true ,cell: (row) => (
      <span className="text-md font-medium">
        {row.projectName}
      </span>
    ), },
    { name: "Start Date", selector: (row) => moment(row.startDate).format("MM-DD-YYYY"), sortable: true },
    { name: "End Date", selector: (row) => moment(row.endDate).format("MM-DD-YYYY"), sortable: true },
    { name: "Budget", selector: (row) => row.budget, sortable: true, hide:'sm' },
    { name: "Net Pay", selector: (row) => row.netPay, sortable: true, hide:"sm" },
    // { name: 'User Id', selector: row => row.userId, sortable: true },
    // { name: 'Client', selector: row => row.clientID, sortable: true },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="text-primary hover:text-primaryDark"
          >
            <MdEdit size={24} />
            <CustomToolTip id="Edit" title="Edit" />
          </button>

          <button
            onClick={() => handleView(row)}
            className="text-primary hover:text-primaryDark"
          >
            <MdVisibility size={24} data-tip data-for="View" />
            <CustomToolTip id="View" title="Details" />
          </button>
        </div>
      ),
    },
  ];
  const initialValues = {
    userId: "",
    projectName: "",
    clientId: "",
    startDate: "",
    endDate: "",
    budget: "",
    netPay: "",
  };

  const handleClose = () => {
    setIsModalOpen({ title: "", isOpen: false });
    dispatch(setResetEditProject());
    dispatch(setResetStateProjectById());
    
    // Don't reset the projects list state here as it will reset pagination
    // Only refresh the data with current pagination state
    dispatch(
      requestProjectsListAction({
        page: projectListState?.page || 0,
        size: projectListState?.size || 10,
        search: search
      })
    );
  };

  const handleDelete = (index) => {
    const updatedData = formData.filter((_, i) => i !== index);
    setFormData(updatedData);
  };

  const handleView = (row) => {
    dispatch(setResetStateProject());
    dispatch(requestProjectById(row.id));
    setIsModalOpen({ title: "View Project", isOpen: true });
  };

  const handlePageChange = (page) => {
    dispatch(
      requestProjectsListAction({
        page: page,
        size: projectListState?.size,
        search: search,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(requestProjectsListAction({ page: 0, size: size, search: search }));
    // setSearch("");
  };

  const handleEdit = (row) => {
    dispatch(setResetStateProject());
    dispatch(requestProjectById(row.id));
    setIsModalOpen({ title: "Edit Project", isOpen: true });
  };

  const handleAddProject = (values) => {
    if (isModalOpen.title === "View Project") {
      return; // Don't do anything in view mode
    }
    if (isModalOpen.title === "Add Project") {
      dispatch(requestProjectAction(values));
    } else {
      const updatedProject = {
        ...values,
        id: projectByIdReducer?.byIdResponse?.id,
      };
      dispatch(requestEditProject(updatedProject));
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(
        requestProjectsListAction({
          page: 0,
          size: projectListState?.size,
          search: search,
        })
      );
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    dispatch(setResetStateProjectsList());
    dispatch(
      requestProjectsListAction({
        page: projectListState?.page,
        size: projectListState?.size,
        
      })
    );
    dispatch(setResetStateProject());
    dispatch(setResetStateProjectById());
    dispatch(setResetEditProject());
    dispatch(requestUsersListActionWithOutPagination("USER"));
    dispatch(requestClientsListActionWithOutPagination());
    setSearch("");
  }, []);

  useEffect(() => {
        if (projectListState?.projectsError && !projectListState?.projectsLoading) {
          toast.error("No Projects fetching / something went wrong");
          dispatch(setResetStateProjectsList());
        }
      }, [projectListState]);

  useEffect(() => {
    if (!addProjectReducer?.isLoading && addProjectReducer?.isResponse) {
      toast.success("Project added successfully");
      dispatch(
        requestProjectsListAction({
          page: projectListState?.page,
          size: projectListState?.size,
          
        })
      );
      handleClose();
      dispatch(setResetStateProject());
    } else if (!addProjectReducer?.isLoading && addProjectReducer?.isError) {
      toast.error("Error adding project");
      dispatch(setResetStateProject());
    }
  }, [addProjectReducer]);

  useEffect(() => {
    if (!projectByIdReducer?.byIdLoading && projectByIdReducer?.byIdResponse) {
      // Don't override the title if it's already set (for view mode)
      if (!isModalOpen.title) {
        setIsModalOpen({ title: "Edit Project", isOpen: true });
      }
    } else if (
      !projectByIdReducer?.byIdLoading &&
      projectByIdReducer?.byIdError
    ) {
      toast.error("Error fetching project data");
      dispatch(setResetStateProjectById());
    }
  }, [projectByIdReducer]);

  useEffect(() => {
    if (!editProjectReducer?.Loading && editProjectReducer?.Response) {
      toast.success("Project updated successfully");
      dispatch(
        requestProjectsListAction({
          page: projectListState?.page,
          size: projectListState?.size,
          search: search
        }) 
      );
      setSearch("");
      handleClose();
      dispatch(setResetEditProject());
    } else if (!editProjectReducer?.Loading && editProjectReducer?.Error) {
      toast.error("Error updating project");
      dispatch(setResetEditProject());
    }
  }, [editProjectReducer]);

  const handleClick = () => {
    setIsModalOpen({ title: "Add Project", isOpen: true });
  }; 

  return (
    <div className="p-6 w-full h-[90vh] overflow-y-scroll">
      <Loader
        isLoading={
          projectListState?.projectsLoading || projectByIdReducer?.byIdLoading ||addProjectReducer?.isLoading || editProjectReducer?.Loading
        }
      />
      <div className="absolute flex  mb-4 z-10 right-6">
        {/* <button
          onClick={handleClick}
          className="flex items-center cursor-pointer float-right justify-center bg-primary hover:bg-primaryDark text-white py-2 px-4 rounded-full shadow-md transition-all duration-300"
        >
          <span className="text-xl cursor-pointer font-extrabold">+</span>
        </button> */}
         <button
          onClick={handleClick}
          className="flex items-center justify-center bg-primary hover:bg-primaryDark text-white py-1 px-6 mr-4 rounded-full shadow-lg transition-all duration-300"
        >
          <span className="text-2xl font-medium">+</span>
        </button>
      </div>

      <CustomDataTable
        columns={columns}
        data={projectListState?.projectsResponse?.content}
        paginationTotalRows={projectListState?.projectsResponse?.totalElements}
        enableSearch={true}
        search={search}
        setSearch={setSearch}
        serverPagenation
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"59vh"}
      />

      <AddProjectModal
        initialValues={
          isModalOpen.title === "Add Project"
            ? initialValues
            : projectByIdReducer?.byIdResponse
        }
        show={isModalOpen.isOpen}
        onClose={handleClose}
        title={isModalOpen.title}
        onAddProject={handleAddProject}
        usersList={usersListState?.response || []}
        clientsList={clientsListState?.response || []}
        // clientsList={clientsListState?.response || []}
        // usersList={Array.isArray(usersListState?.response) ? usersListState.response : []}
        // clientsList={Array.isArray(clientsListState?.response) ? clientsListState.response : []}
      />
    </div>
  );
};

export default Hoc(AddProject);
